














































































import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { OktaSignInWidgetBuilder } from "@/shared/oktaSignInWidgetWrapper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useSignUpStore } from "@/employee/store/signup";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { useThemeStore } from "@/shared/store/theme";
import passwordValidation from "@/shared/passwordValidation";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import PasswordSetup from "@/employee/components/shared/PasswordSetup.vue";

@Component({
  components: {
    HsaBankOnboardingFooter,
    Button,
    LoginWrapper,
    GenericLoadingSpinner,
    PasswordSetup
  }
})
export default class LoginInfo extends Vue {
  signupStore = useSignUpStore();
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  isProcessing = false;
  password = "";
  username = "";
  showStartOverButton = false;
  widget = new OktaSignInWidgetBuilder("#okta-signin-container-auto-login");
  isSubmitting = false;

  get submitDisabled () {
    return this.isSubmitting;
  }

  get invalidState (): boolean {
    return !this.signupStore.isEmailVerified || this.signupStore.bendUserId === "" || this.signupStore.bendUserId === undefined;
  }

  onSubmit () {
    this.isSubmitting = true;

    this.validateAll()
      .then(isValid => {
        this.isSubmitting = false;

        if (!isValid) {
          return;
        }

        return this.submitCreateLoginRequest();
      })
      .catch(() => {
        this.isSubmitting = false;
      });
  }

  validateAll () {
    return this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return Promise.resolve(false);
        }

        return passwordValidation.validate(this.password);
      })
      .catch(error => {
        let message = "Please choose another password.";

        if (error && error.message) {
          message = error.message;
        }

        this.notifierStore.setDanger(message);

        return Promise.resolve(false);
      });
  }

  submitCreateLoginRequest () {
    this.isProcessing = true;
    this.showStartOverButton = false;

    return this.signupStore.individualSignupCreateLogin({
        bendUserId: this.signupStore.bendUserId,
        signature: this.signupStore.signature,
        username: this.username,
        password: this.password
      })
      .then(() => this.signIn())
      .catch(() => {
        this.isProcessing = false;
        this.showStartOverButton = true;
      });
  }

  signIn () {
    this.widget
      .signInWithoutPromptAndSetTokens(this.username, this.password)
      .then(() => this.userStore.processEnrollmentLogin())
      .catch(() => {
        this.isProcessing = false;
        this.userStore.logout();
        this.userStore.setLoginUsername(this.username);
        this.$router.push({ name: LoginRouteNames.OktaLogin });
        this.notifierStore.setDanger("Unable to login, please try again");
      });
  }

  destroyed () {
    this.widget.destroyed();
  }
}
